import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imRepeaterConfigurator', {
        template:
            require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/periodic_tasks/repeater_configurator/repeater_configurator.html'),
        controller: 'RepeaterConfiguratorController',
        controllerAs: 'RepeaterConfiguratorCtrl',
        bindings: {
            configuration: '=',
            initialConfiguration: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/periodic_tasks/repeater_configurator/repeater_configurator.component.ts